// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard_Dashboard__25Mwp","DashGrid":"Dashboard_DashGrid__cYPVM"};